import { pluralize } from "@common/helpers/string";
import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";

interface TasksBulkDeleteModalProps {
    show: boolean;
    selectedCount: number;
    onConfirm: () => void;
    onClose: () => void;
}

/** Asks before the bulk actions palette's Delete removes the selected tasks. */
export const TasksBulkDeleteModal = ({
    show,
    selectedCount,
    onConfirm,
    onClose,
}: Readonly<TasksBulkDeleteModalProps>) => (
    <ConfirmationModal
        show={show}
        title={`Delete ${selectedCount} ${pluralize("task", selectedCount)}?`}
        question="This action can't be undone."
        yes="Delete"
        yesBtnVariant="destructive"
        no="Cancel"
        onConfirm={onConfirm}
        onReject={onClose}
        onHide={onClose}
    />
);
